import type IAccountState from './types'

export const initialState: IAccountState = {
  signatureSet: {
    status: 0,
    uploadProgress: 0,
    cancelToken: undefined,
    fileId: undefined,
  },
}
